var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _path12, _path13, _path14, _path15, _path16, _g11, _path17, _path18, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldRankIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17561_52994)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17561_52994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 0,
    width: 22,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2751 40.848H52.4392L45.8164 0H66.9118L60.2751 40.848Z",
    fill: "url(#paint0_linear_17561_52994)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17561_52994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2751 40.848H52.4392L45.8164 0H66.9118L60.2751 40.848Z",
    fill: "url(#paint1_linear_17561_52994)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_17561_52994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 4,
    width: 36,
    height: 43
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6536 41.4355L44.3096 46.0503L15.002 16.9211L32.0818 4.4751L50.6536 41.4355Z",
    fill: "url(#paint2_linear_17561_52994)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_17561_52994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6536 41.4355L44.3096 46.0503L15.002 16.9211L32.0818 4.4751L50.6536 41.4355Z",
    fill: "url(#paint3_linear_17561_52994)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_17561_52994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 28,
    width: 44,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2086 47.5886L40.7826 55.0562L0 48.7633L6.52521 28.626L43.2086 47.5886Z",
    fill: "url(#paint4_linear_17561_52994)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_17561_52994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2086 47.5886L40.7826 55.0562L0 48.7633L6.52521 28.626L43.2086 47.5886Z",
    fill: "url(#paint5_linear_17561_52994)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_17561_52994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 56,
    width: 44,
    height: 28
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7826 56.9438L43.2086 64.4114L6.52521 83.3741L0 63.2368L40.7826 56.9438Z",
    fill: "url(#paint6_linear_17561_52994)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_17561_52994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7826 56.9438L43.2086 64.4114L6.52521 83.3741L0 63.2368L40.7826 56.9438Z",
    fill: "url(#paint7_linear_17561_52994)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_17561_52994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 65,
    width: 36,
    height: 43
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3096 65.9497L50.6536 70.5645L32.0818 107.525L15.002 95.0789L44.3096 65.9497Z",
    fill: "url(#paint8_linear_17561_52994)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_17561_52994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3096 65.9497L50.6536 70.5645L32.0818 107.525L15.002 95.0789L44.3096 65.9497Z",
    fill: "url(#paint9_linear_17561_52994)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_17561_52994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 71,
    width: 22,
    height: 41
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4392 71.1519H60.2751L66.9118 112H45.8164L52.4392 71.1519Z",
    fill: "url(#paint10_linear_17561_52994)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_17561_52994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4392 71.1519H60.2751L66.9118 112H45.8164L52.4392 71.1519Z",
    fill: "url(#paint11_linear_17561_52994)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_17561_52994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 65,
    width: 36,
    height: 43
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0732 70.5645L68.4033 65.9497L97.7109 95.0789L80.645 107.525L62.0732 70.5645Z",
    fill: "url(#paint12_linear_17561_52994)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_17561_52994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0732 70.5645L68.4033 65.9497L97.7109 95.0789L80.645 107.525L62.0732 70.5645Z",
    fill: "url(#paint13_linear_17561_52994)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_17561_52994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 56,
    width: 44,
    height: 28
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5186 64.4114L71.9307 56.9438L112.727 63.2368L106.202 83.3741L69.5186 64.4114Z",
    fill: "url(#paint14_linear_17561_52994)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_17561_52994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5186 64.4114L71.9307 56.9438L112.727 63.2368L106.202 83.3741L69.5186 64.4114Z",
    fill: "url(#paint15_linear_17561_52994)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_17561_52994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 28,
    width: 44,
    height: 28
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9307 55.0562L69.5186 47.5886L106.202 28.626L112.727 48.7633L71.9307 55.0562Z",
    fill: "url(#paint16_linear_17561_52994)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_17561_52994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9307 55.0562L69.5186 47.5886L106.202 28.626L112.727 48.7633L71.9307 55.0562Z",
    fill: "url(#paint17_linear_17561_52994)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_17561_52994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 4,
    width: 36,
    height: 43
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4033 46.0503L62.0732 41.4355L80.645 4.4751L97.7109 16.9211L68.4033 46.0503Z",
    fill: "url(#paint18_linear_17561_52994)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_17561_52994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4033 46.0503L62.0732 41.4355L80.645 4.4751L97.7109 16.9211L68.4033 46.0503Z",
    fill: "url(#paint19_linear_17561_52994)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9506 86.0844C75.2532 86.0844 90.9011 70.3955 90.9011 51.0422C90.9011 31.6889 75.2532 16 55.9506 16C36.6479 16 21 31.6889 21 51.0422C21 70.3955 36.6479 86.0844 55.9506 86.0844Z",
    fill: "url(#paint20_linear_17561_52994)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9508 83.8378C74.0159 83.8378 88.6604 69.1548 88.6604 51.0424C88.6604 32.9301 74.0159 18.2471 55.9508 18.2471C37.8858 18.2471 23.2412 32.9301 23.2412 51.0424C23.2412 69.1548 37.8858 83.8378 55.9508 83.8378Z",
    fill: "url(#paint21_linear_17561_52994)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9503 82.54C73.3004 82.54 87.3655 68.438 87.3655 51.0424C87.3655 33.6468 73.3004 19.5449 55.9503 19.5449C38.6002 19.5449 24.5352 33.6468 24.5352 51.0424C24.5352 68.438 38.6002 82.54 55.9503 82.54Z",
    fill: "url(#paint22_linear_17561_52994)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0867 94.0949C74.2815 96.0626 72.305 97.528 70.4816 96.7465L61.476 92.9227L55.0733 90.2013L48.6706 92.9227L39.5675 96.7883C37.772 97.5559 35.8094 96.1324 35.9625 94.1926L38.2313 64.2441H71.1497L74.0867 94.0949Z",
    fill: "url(#paint23_linear_17561_52994)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4763 70.7891V92.9364L55.0736 90.2151L48.6709 92.9364V70.7891H61.4763Z",
    fill: "#EDF5FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_17561_52994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 28,
    width: 51,
    height: 51
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9867 30.681C63.4247 26.8711 69.73 29.4808 69.4795 34.6164C69.3124 37.8541 71.9709 40.5196 75.2001 40.3521C80.3223 40.087 82.9391 46.4227 79.1253 49.8697C76.7312 52.0328 76.7312 55.8148 79.1253 57.9779C82.9252 61.4249 80.3223 67.7467 75.2001 67.4955C71.9709 67.328 69.3124 69.9935 69.4795 73.2312C69.7439 78.3668 63.4247 80.9905 59.9867 77.1667C57.8293 74.7663 54.0572 74.7663 51.8998 77.1667C48.4618 80.9765 42.1565 78.3668 42.407 73.2312C42.5741 69.9935 39.9155 67.328 36.6863 67.4955C31.5641 67.7607 28.9474 61.4249 32.7612 57.9779C35.1552 55.8148 35.1552 52.0328 32.7612 49.8697C28.9613 46.4227 31.5641 40.1009 36.6863 40.3521C39.9155 40.5196 42.5741 37.8541 42.407 34.6164C42.1426 29.4808 48.4618 26.8572 51.8998 30.681C54.0711 33.0953 57.8293 33.0953 59.9867 30.681Z",
    fill: "url(#paint24_linear_17561_52994)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_17561_52994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9867 30.6815C63.4247 26.8716 69.73 29.4813 69.4795 34.6169C69.3124 37.8546 71.9709 40.5201 75.2001 40.3526C80.3223 40.0874 82.9391 46.4232 79.1253 49.8702C76.7312 52.0333 76.7312 55.8153 79.1253 57.9784C82.9252 61.4254 80.3223 67.7472 75.2001 67.496C71.9709 67.3285 69.3124 69.994 69.4795 73.2317C69.7439 78.3673 63.4247 80.9909 59.9867 77.1671C57.8293 74.7668 54.0572 74.7668 51.8998 77.1671C48.4618 80.977 42.1565 78.3673 42.407 73.2317C42.5741 69.994 39.9155 67.3285 36.6863 67.496C31.5641 67.7612 28.9474 61.4254 32.7612 57.9784C35.1552 55.8153 35.1552 52.0333 32.7612 49.8702C28.9613 46.4232 31.5641 40.1014 36.6863 40.3526C39.9155 40.5201 42.5741 37.8546 42.407 34.6169C42.1426 29.4813 48.4618 26.8577 51.8998 30.6815C54.0711 33.0958 57.8293 33.0958 59.9867 30.6815Z",
    fill: "url(#paint25_linear_17561_52994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9867 27.8065C63.4247 23.9966 69.73 26.6063 69.4795 31.7419C69.3124 34.9796 71.9709 37.6451 75.2001 37.4776C80.3223 37.2125 82.9391 43.5482 79.1253 46.9952C76.7312 49.1583 76.7312 52.9403 79.1253 55.1034C82.9252 58.5504 80.3223 64.8722 75.2001 64.621C71.9709 64.4535 69.3124 67.119 69.4795 70.3567C69.7439 75.4923 63.4247 78.116 59.9867 74.2922C57.8293 71.8918 54.0572 71.8918 51.8998 74.2922C48.4618 78.102 42.1565 75.4923 42.407 70.3567C42.5741 67.119 39.9155 64.4535 36.6863 64.621C31.5641 64.8862 28.9474 58.5504 32.7612 55.1034C35.1552 52.9403 35.1552 49.1583 32.7612 46.9952C28.9613 43.5482 31.5641 37.2264 36.6863 37.4776C39.9155 37.6451 42.5741 34.9796 42.407 31.7419C42.1426 26.6063 48.4618 23.9827 51.8998 27.8065C54.0711 30.2068 57.8293 30.2068 59.9867 27.8065Z",
    fill: "url(#paint26_linear_17561_52994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9501 67.7468C65.1517 67.7468 72.6111 60.2679 72.6111 51.0421C72.6111 41.8164 65.1517 34.3374 55.9501 34.3374C46.7485 34.3374 39.2891 41.8164 39.2891 51.0421C39.2891 60.2679 46.7485 67.7468 55.9501 67.7468Z",
    fill: "url(#paint27_linear_17561_52994)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0489 42.927C55.3483 42.0057 56.6517 42.0057 56.9511 42.9271L58.2451 46.9098C58.379 47.3219 58.763 47.6008 59.1962 47.6008H63.3839C64.3527 47.6008 64.7554 48.8404 63.9717 49.4098L60.5838 51.8713C60.2333 52.126 60.0866 52.5773 60.2205 52.9894L61.5146 56.9721C61.8139 57.8934 60.7595 58.6596 59.9757 58.0902L56.5878 55.6287C56.2373 55.374 55.7627 55.374 55.4122 55.6287L52.0243 58.0902C51.2405 58.6596 50.1861 57.8934 50.4854 56.9721L51.7795 52.9894C51.9134 52.5773 51.7667 52.126 51.4162 51.8713L48.0283 49.4098C47.2446 48.8404 47.6473 47.6008 48.6161 47.6008H52.8038C53.237 47.6008 53.621 47.3219 53.7549 46.9098L55.0489 42.927Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78C93 75.2319 90.7536 73 88 73C90.7681 73 93 70.7536 93 68C93 70.7681 95.2464 73 98 73C95.2464 73 93 75.2319 93 78Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 59C25.5 57.0695 23.9305 55.5 22 55.5C23.9305 55.5 25.5 53.9305 25.5 52C25.5 53.9305 27.0695 55.5 29 55.5C27.0695 55.5 25.5 57.0695 25.5 59Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 32C80.8807 32 82 30.8807 82 29.5C82 28.1193 80.8807 27 79.5 27C78.1193 27 77 28.1193 77 29.5C77 30.8807 78.1193 32 79.5 32Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87 19.5C87 20.3239 86.3239 21 85.5 21C84.6761 21 84 20.3239 84 19.5C84 18.6761 84.6761 18 85.5 18C86.3239 18 87 18.6761 87 19.5Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25 71.5C25 72.3239 24.3239 73 23.5 73C22.6761 73 22 72.3239 22 71.5C22 70.6761 22.6761 70 23.5 70C24.3239 70 25 70.6761 25 71.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17561_52994",
    x1: 56.3615,
    y1: 40.8506,
    x2: 56.3615,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17561_52994",
    x1: 56.3615,
    y1: 40.8506,
    x2: 56.3615,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17561_52994",
    x1: 47.4831,
    y1: 43.7436,
    x2: 23.4489,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17561_52994",
    x1: 47.4831,
    y1: 43.7436,
    x2: 23.4489,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17561_52994",
    x1: 41.9962,
    y1: 51.3177,
    x2: 3.2376,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17561_52994",
    x1: 41.9962,
    y1: 51.3177,
    x2: 3.2376,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17561_52994",
    x1: 41.9962,
    y1: 60.6825,
    x2: 3.23759,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17561_52994",
    x1: 41.9962,
    y1: 60.6825,
    x2: 3.23759,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_17561_52994",
    x1: 47.4831,
    y1: 68.2566,
    x2: 23.4488,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_17561_52994",
    x1: 47.4831,
    y1: 68.2566,
    x2: 23.4488,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_17561_52994",
    x1: 56.3615,
    y1: 71.1494,
    x2: 56.3615,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_17561_52994",
    x1: 56.3615,
    y1: 71.1494,
    x2: 56.3615,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_17561_52994",
    x1: 65.2385,
    y1: 68.2566,
    x2: 89.2727,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_17561_52994",
    x1: 65.2385,
    y1: 68.2566,
    x2: 89.2727,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_17561_52994",
    x1: 70.7257,
    y1: 60.6825,
    x2: 109.484,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_17561_52994",
    x1: 70.7257,
    y1: 60.6825,
    x2: 109.484,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_17561_52994",
    x1: 70.7257,
    y1: 51.3177,
    x2: 109.484,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_17561_52994",
    x1: 70.7257,
    y1: 51.3177,
    x2: 109.484,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_17561_52994",
    x1: 65.2385,
    y1: 43.7436,
    x2: 89.2727,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_17561_52994",
    x1: 65.2385,
    y1: 43.7436,
    x2: 89.2727,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_17561_52994",
    x1: 55.9456,
    y1: 86.08,
    x2: 55.9456,
    y2: 16.0021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6AE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEDE86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_17561_52994",
    x1: 55.9459,
    y1: 83.8298,
    x2: 55.9459,
    y2: 18.2527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E89B05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_17561_52994",
    x1: 55.9453,
    y1: 82.5359,
    x2: 55.9453,
    y2: 19.5466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9AA09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_17561_52994",
    x1: 55.0288,
    y1: 97.0042,
    x2: 55.0288,
    y2: 64.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_17561_52994",
    x1: 55.9452,
    y1: 78.9837,
    x2: 55.9452,
    y2: 28.8699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_17561_52994",
    x1: 55.9452,
    y1: 78.9842,
    x2: 55.9452,
    y2: 28.8704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_17561_52994",
    x1: 30.9538,
    y1: 51.0412,
    x2: 80.9366,
    y2: 51.0412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD674"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_17561_52994",
    x1: 55.9451,
    y1: 67.7456,
    x2: 55.9451,
    y2: 34.3363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB0D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17561_52994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.727,
    height: 112,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldRankIcon);
export default __webpack_public_path__ + "static/media/GoldRankIcon.34fc12aa.svg";
export { ForwardRef as ReactComponent };